import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useStore } from "@/context/StoreContext";

export default function Seo({ title, description, image, jsonLd, type = "website" }) {
  const { pathname } = useLocation();
  const { settings } = useStore();
  const origin = settings.site_url || window.location.origin;
  const url = `${origin}${pathname}`;
  const fullTitle = title ? `${title} — DEMOIVRE` : "DEMOIVRE — Mechanical Engineering as Art";
  const img = image ? (image.startsWith("http") ? image : `${origin}${image}`) : "";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="DEMOIVRE" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content={img ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {img && <meta name="twitter:image" content={img} />}
      {settings.google_site_verification && (
        <meta name="google-site-verification" content={settings.google_site_verification} />
      )}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
